const Roles = Object.freeze({
  WUNA_ADMIN: 'WUNA_ADMIN',
  ENTERPRISE_USER: 'ENTERPRISE_USER',
  THIRD_PARTY: 'THIRD_PARTY',
  VERIFIER: 'VERIFIER',
  END_USER: 'END_USER',
  END_USER_UNVERIFIED: 'END_USER_UNVERIFIED',
});

export default Roles;

const RoleTitles = Object.freeze({
  WUNA_ADMIN: 'WUNA Admin',
  ENTERPRISE_USER: 'Privacy Officer',
  THIRD_PARTY: 'Third Party Verifier',
  VERIFIER: 'Verifier',
  END_USER: 'End User',
  END_USER_UNVERIFIED: 'Unverified End User',
});

export { RoleTitles };
